import React from "react";
import SortableHeaderCell from "components/SortableHeaderCell";
import { getRealAge } from "util/lifterHelper";
import { Column } from "components/table/Table";
import { Meet } from "types";

const AgeCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties & { fontSize: number };
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return <SortableHeaderCell style={style} column={column} />;
  } else {
    return (
      <div style={style} className="table-cell-inner">
        {getRealAge(lifter, meet)}
      </div>
    );
  }
};

export default AgeCell;
